import { onTabReturn } from './onTabReturn'

// Longer delays overflow and make setTimeout fire immediately
const MAX_TIMEOUT_DELAY_MS = 2 ** 31 - 1

// Runs the callback once the time is reached, and again whenever the user comes
// back to the tab after that. setTimeout is paused while the system sleeps, so
// the time is also checked then. Returns a function that stops it.
export const runWhenTimeReached = (time: number, callback: () => void) => {
  let timeoutId: ReturnType<typeof setTimeout> | undefined

  const check = () => {
    if (timeoutId) clearTimeout(timeoutId)

    const delay = time - Date.now()
    if (delay <= 0) {
      callback()
      return
    }

    timeoutId = setTimeout(check, Math.min(delay, MAX_TIMEOUT_DELAY_MS))
  }

  check()
  const stopCheckingOnTabReturn = onTabReturn(check)

  return () => {
    if (timeoutId) clearTimeout(timeoutId)
    stopCheckingOnTabReturn()
  }
}
